<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          icon
          small
          :class="active ? `v-btn--active` : ``"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
      >
        <v-icon>mdi-table</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()">
        <v-list-item-title>{{$t('insertTable')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().deleteTable().run()" :disabled="!editor.can().deleteTable()">
        <v-list-item-title>{{$t('deleteTable')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().addColumnBefore().run()" :disabled="!editor.can().addColumnBefore()">
        <v-list-item-title>{{$t('addColumnBefore')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().addColumnAfter().run()" :disabled="!editor.can().addColumnAfter()">
        <v-list-item-title>{{$t('addColumnAfter')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().deleteColumn().run()" :disabled="!editor.can().deleteColumn()">
        <v-list-item-title>{{$t('deleteColumn')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().addRowBefore().run()" :disabled="!editor.can().addRowBefore()">
        <v-list-item-title>{{$t('addRowBefore')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().addRowAfter().run()" :disabled="!editor.can().addRowAfter()">
        <v-list-item-title>{{$t('addRowAfter')}}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editor.chain().focus().deleteRow().run()" :disabled="!editor.can().deleteRow()">
        <v-list-item-title>{{$t('deleteRow')}}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "TableButton",
  props: {
    editor: Object,
    active: Boolean,
    disabled: Boolean,
  }
}
</script>

<style scoped>

</style>

<i18n lang="i18n">
{
  "en": {
    "insertTable": "Insert table",
    "deleteTable": "Delete table",
    "addColumnBefore": "Add column before",
    "addColumnAfter": "Add column after",
    "deleteColumn": "Delete column",
    "addRowBefore": "Add row before",
    "addRowAfter": "Add row after",
    "deleteRow": "Delete row"
  },
  "pl": {
    "insertTable": "Wstaw tabele",
    "deleteTable": "Usuń tabele",
    "addColumnBefore": "Wstaw kolumnę przed",
    "addColumnAfter": "Wstaw kolumne po",
    "deleteColumn": "Usuń kolumne",
    "addRowBefore": "Wstaw wiersz przed",
    "addRowAfter": "Wstaw wiersz po",
    "deleteRow": "Usuń wiersz"
  }
}
</i18n>
